upstack.controller('calculatorCtrl', ['$location', '$scope', function($location, $scope){
    var vm = this;
    vm.params = $location.search();
    vm.company = {
        name: $location.search().c || 'MealPal',
        url: $location.search().u || 'mealpal.com'
    };
    vm.calculator = {
        hr_salary: $location.search().hr || 75000,
        dev_salary: $location.search().dev || 150000,
        hires: $location.search().hires || 3
    };
    vm.updateUrl = function() {
        var query = '?c=' + vm.company.name + '&u=' + vm.company.url + '&hr=' + vm.calculator.hr_salary + '&dev=' + vm.calculator.dev_salary + '&hires=' + vm.calculator.hires;
        history.pushState("", document.title, window.location.pathname + query);
    };
    vm.parseInt = parseInt;
    vm.raw = JSON.stringify(vm.calculator);
    vm.calculator.hour_savings  = vm.calculator.hires * 30;
    vm.calculator.hr_savings    = vm.calculator.hr_salary / 12 / 160 * 50 * vm.calculator.hires;
    vm.calculator.dev_savings   = (vm.calculator.dev_salary-9600) / 12 * vm.calculator.hires;
    vm.calculator.cost_savings  = vm.calculator.hr_savings + vm.calculator.dev_savings;
}]);
